import { Button } from "antd";
import styled from "styled-components";

export const StyledContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  padding: 8px 0;
`;

export const StyledLabelValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fafbfc;
  text-align: right;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 15px;
  .label {
    font-weight: 600;
    color: #444;
    min-width: 110px;
  }
  .value {
    color: #222;
    word-break: break-all;
  }
`;

export const StyledCopyButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  font-size: 1.15rem;
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
`;
